import { createSelector } from '@reduxjs/toolkit'
import type { RootState } from 'Utils/store'
import { multiSelectSlice } from 'Slices/multiSelectSlice'
import MilitaryPreferenceConfig from 'Configs/fields/military_preference.json'
import { ContractSource } from 'Types/contractTypes'

const contractSource = ContractSource.candidates

const transformValues = function (selectedValues) {
  return selectedValues.map((value) => (value === 'None Selected' ? '' : value))
}

export const MilitaryPreferencesSlice = multiSelectSlice(
  MilitaryPreferenceConfig.column,
  'setMilitaryPreference',
  MilitaryPreferenceConfig.data,
  MilitaryPreferenceConfig.meta,
  transformValues
)

export const selectMilitaryPreferences = createSelector(
  ({ onDemandFilter: { prospectProfile } }: RootState) =>
    prospectProfile.militaryPreferences.selectedValues,
  (
    selectedValues: string[]
  ): {
    selectedValues: string[]
    values: string[]
    audienceTypes: string[]
    label
  } => {
    return {
      selectedValues,
      values: MilitaryPreferenceConfig.data,
      audienceTypes: MilitaryPreferenceConfig.source[contractSource].audience_types,
      label: MilitaryPreferenceConfig.meta.label,
    }
  }
)

export const { setMilitaryPreference } = MilitaryPreferencesSlice.actions

export default MilitaryPreferencesSlice.reducer
